import React from 'react';

const VideosContext = React.createContext({
    channels: [],
    allVideos: [],
    blockchainVideos: [],
    contract: null,
    owner: '',
    appProfits: '0',
    previewModal: false,
    buyModal: false,
    buyModalSrc: {},
    mintUploadProgress: 0,
    preview: '',
    subscribers: [],
    transactionLoading: false,
    uploadingProgress: false,
    activities: [],
    watchList: null,
    userRefCode: null,
    videoSingleData: null,
    userVideos: [],
    loadVideos: () => {},
    loadContract: () => {},
    loadAllChannels: () => {},
    loadVideoSubscribers: () => {},
    loadAppOwner: () => {},
    setTransactionLoading: () => {},
    setPreviewSrc: () => {},
    setPreviewModal: () => {},
    setBuyModal: () => {},
    setBuyModalSrc: () => {},
    loadMintUploadProgress: () => {},
    loadAppProfits: () => {},
    setUploadingProgress: () => {},
    loadActivities: () => {},
    loadUserWatchlist: () => {},
    loadUserRefCode: () => {},
    loadUserChannels: () => {},
    loadSingleVideo: () => {},
});

export default VideosContext;
